import script from "./ExpiryTableSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpiryTableSection.vue?vue&type=script&setup=true&lang=ts"

import "./ExpiryTableSection.vue?vue&type=style&index=0&id=d75272ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75272ce"]])

export default __exports__